import styled from 'styled-components'

export const SelectWrapper = styled.div<{ source?: string }>`
  display: flex;
  max-width: 295px;
  justify-content: center;
  margin-left: auto;
  input[type='text'] {
    font-family: var(--font-family-body);
  }

  button {
    padding: 0 var(--space-sm);
    height: var(--control-size-md);
    color: var(--color-text-neutral);
    font-family: var(--font-family-body);
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-body);
  }

  div[class*='Button__ButtonWrapperStyled'] {
    border-radius: var(--border-radius-sm);
    background-color: transparent;
    border: 1px solid var(--color-border-neutral);

    &:hover {
      background-color: var(--color-bg-a-subtle);
    }

    .vrLight &,
    .vrDark & {
      border-radius: var(--border-radius-full);
      border-color: var(--color-border-subtle);
    }
  }

  div[class*='SelectStyled'] {
    width: 295px;
    right: 0;
    left: unset;
    background-color: var(--color-bg-surface-floating);
    border: none;
    box-shadow: var(--shadow-menu);
    border-radius: var(--border-radius-sm);

    input[type='checkbox'] {
      accent-color: var(--color-bg-brand);
      .vrLight &,
      .vrDark & {
        accent-color: var(--color-bg-brand-xstrong);
      }
    }

    div[class*='CustomItemContainer'] {
      border-radius: 0 0 4px 4px;
    }

    ul[class*='SelectItems'] {
      background-color: transparent;
      li {
        color: var(--color-text-neutral);

        &:hover {
          background-color: var(--color-bg-subtle);

          :global(.vrLight) &,
          :global(.vrDark) & {
            background-color: var(--color-bg-a-subtle);
          }
        }
      }
    }
  }

  #searchInput {
    padding: 16px 16px 8px 16px;
    border: none;

    svg {
      display: none;
    }

    div[class*='SearchWrapper'] {
      margin: 0;
      position: relative;

      input {
        height: unset;
        padding: 8px;
        background-color: var(--color-bg-neutral);
        padding: var(--space-xs);
        border: 1px solid var(--color-border-subtle);
        transition: all 0.1s ease-out;
        border-radius: var(--border-radius-sm);

        &:focus {
          outline: 2px solid var(--focus-color);
          outline-offset: 1px;
          border: 1px solid var(--color-border-brand);
        }
      }
    }
  }

  ul {
    padding: 0 12px 12px;

    li {
      padding: 8px;
      min-height: unset;
      margin: 0;

      > div {
        padding: 0;
      }

      p {
        margin-left: 0 !important;
      }

      input[type='checkbox'] {
        height: 16px;
        width: 16px;
        margin: 0 12px 0 0;
      }

      span[class*='IconWrapper'] {
        margin-right: 6px;
      }

      div[class*='Color'] {
        margin: 0;
      }
    }
  }

  ${({ source }): string | false =>
    source === 'postsComposer' &&
    `
    button {
      padding: var(--space-xs) var(--space-sm);
      height: unset;
    }
  `}
`

export const Color = styled.div<{ $smallMargin?: boolean; color: string }>`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background-color: ${(props): string => props.color};
  margin-right: ${(props): string => (props.$smallMargin ? '6px' : '10px')};
  display: flex;
  flex-shrink: 0;
`

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  p {
    margin-left: 0;
  }

  span {
    margin-right: 8px;
  }
`

export const TagLabelWrapper = styled.div`
  display: flex;
`

export const TagCheckboxWrapper = styled.input<{ disabled: boolean }>`
  margin-right: 12px;
  cursor: pointer;
  pointer-events: ${({ disabled }): string => (disabled ? 'none' : 'auto')};
`
